import React, { memo } from "react";

const FreeAuthRoute = memo(function FreeAuthRoute({ children }) {
  return children;
});

export default FreeAuthRoute;
